module.exports = __webpack_public_path__ + "media/images/konintodoke/diagnosis/sasurai_bokenka-b192e1adecf70773993da1f8a3f16c57.png";